module.exports = __webpack_public_path__ + "img/img_sepem.e03c45ee.jpg";